<script>
import axios from 'axios'
import ProgressBar from 'primevue/progressbar';
import {AppConstant} from "../app.constant";

export default {
    props: {
        rest: null,
        showProgress: false
    },
    data() {
        return {
            progress: 0,
            saveTitle: document.title,
            windowReloaded: false
        }
    },
    methods: {
        init: function (event) {
            let self = this;
            axios({
                method: 'get',
                url: this.getApiUrl,
                withCredentials: true
            })
                .then(function (response) {

                    if (response.data.progress) {
                        self.progress = response.data.progress;
                        document.title = self.title;
                    }

                    // Поддержка ai_state (для ИИ-отчётов) и state (для других отчётов)
                    const currentState = response.data.ai_state !== undefined ? response.data.ai_state : response.data.state;
                    if (currentState === 10 || currentState === 2) {
                        if (!self.windowReloaded) {
                            self.windowReloaded = true;
                            window.location.reload();
                        }
                    } else {
                        setTimeout(() => self.init(), AppConstant.TIMEOUT_WAITER_REQUEST);
                    }
                })
                .catch(function (error) {
                    //console.log(error);
                });

        },
        changeFavicon() {
            document.querySelector("link[rel='icon']").href = "/waitfavicon.ico";
        }
    },
    computed: {
        getApiUrl() {
            return this.$config.API_URL + this.rest;
        },
        title() {
            return `${this.progress}% ${this.saveTitle}`;
        }
    },
    created() {
        this.changeFavicon();
        this.init();

    },
    components: {
        ProgressBar
    },
}
</script>
<template>
    <ProgressBar v-if="showProgress" :value="progress"></ProgressBar>
</template>
